import React, { ReactNode } from "react";

import styles from "./FlowSidebar.module.scss";

interface Props {
  children: ReactNode;
  title: string | ReactNode;
  titleId?: string;
}

export const FlowSidebar = ({ children, title, titleId }: Props) => (
  <section className={styles.flowSidebar__wrapper} aria-labelledby={titleId}>
    <div className={styles.flowSidebar__header}>
      <h2 id={titleId}>{title}</h2>
    </div>
    {children}
  </section>
);
